import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useOutletContext } from "react-router-dom";
import Box from "@mui/material/Box";

import {
  StyledTabContentContainer,
  StyledNoMacroContainer,
  StyledNoMacroText,
} from "./TabContent.styles";
import QuestionBlock from "../QuestionBlock/QuestionBlock";
import { get, isEmpty } from "lodash-es";

import { fetchMacroListAsyncAction } from "features/metadesk/redux/macro/macro.action";
import {
  selectMacroList,
  selectMacroIsLoading,
} from "features/metadesk/redux/macro/macro.selector";
import LoadingComponent from "components/LoadingComponent/LoadingComponent";
import EmptyAddContent from "components/EmptyState/EmptyAddContent";
import useGetPagePermission from "hooks/useGetPagePermission";
import { useIntl } from "react-intl";

const TabContent = ({
  category,
  onLinkifyOptions,
  onSearchValue,
  onOpenEditMacroModal,
}) => {
  const { formatMessage } = useIntl();
  const [entityName] = useOutletContext();

  const dispatch = useDispatch();
  const macroList = useSelector(selectMacroList);
  const macroIsLoading = useSelector(selectMacroIsLoading);
  const categoryId = get(category, "_id", "");
  const pagePermission = useGetPagePermission();
  const { canEdit } = pagePermission("macros");

  useEffect(() => {
    dispatch(
      fetchMacroListAsyncAction({
        entityName: entityName,
        category: categoryId,
        search: onSearchValue,
      })
    );
  }, [categoryId, onSearchValue]);

  if (macroIsLoading) {
    return (
      <Box
        sx={{
          minHeight: "50vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}>
        <LoadingComponent />
      </Box>
    );
  }

  if (isEmpty(macroList) && canEdit)
    return (
      <EmptyAddContent
        buttonText={formatMessage({
          id: "macrosSetting.macrosCreate.title",
        })}
        sx={{ height: "89px" }}
        onClick={onOpenEditMacroModal}
        className="fade-up-more"
      />
    );

  return (
    <StyledTabContentContainer className="fade-up-more">
      {macroList.map((macro) => (
        <QuestionBlock
          key={macro._id}
          macro={macro}
          onLinkifyOptions={onLinkifyOptions}
          onOpenEditMacroModal={onOpenEditMacroModal}
          tabCategoryId={categoryId}
        />
      ))}
    </StyledTabContentContainer>
  );
};

export default TabContent;
